
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import OffenDatatable from '@/components/Impfverwaltung/Offen/OffenDatatable.vue';
    import { PlanItem } from '@/types/Reiseplan';
    import Planimpfung from '@/types/Planimpfung';
    import PatUntersuchung from '@/types/PatUntersuchung';

    @Component({
        components: {
            OffenDatatable
        },
        computed: {
            ...mapState('patient', ['patientData', 'dialogs', 'loaders']),
            ...mapGetters('patient', ['getOffeneImpfungen', 'getOffeneUntersuchungen']),

        },
        methods: {
            ...mapActions('patient', ['setDurchgefuehrt', 'resetDurchgefuehrt']),
        }
    })
    export default class OffenTabitem extends Vue {
        public selected: PlanItem<Planimpfung | PatUntersuchung>[] = [];
        public patientData!: any;
        public setDurchgefuehrt!: (payload? : any) => void;
        public resetDurchgefuehrt!: (payload? : any) => void;

        public reset(): void {
            this.selected = [];
        }

        public get isDurchgefuehrtDisabled() {
            if (this.selected.length === 0) {
                return true;
            } else if (this.selected.length > 0) {
                var res = false;
                for (var cnt = 0; cnt < this.selected.length; cnt++) {
                    if (this.selected[cnt].isImpfung && this.selected[cnt].asImpfung.impfdatum) {
                        res = true;
                    }
                    if (this.selected[cnt].asUntersuchung && (this.selected[cnt].asUntersuchung.untersuchungsdatum ||
                        this.selected[cnt].asUntersuchung.abnahmedatum)) {
                        res = true;
                    }
                }
                return res;
            } else return false;
        }

        @Watch('dialogs.impfungNew')
        public onChangeDialogsImpfung(visible: boolean): void {
            if (!visible) {
                this.reset();
            }
        }

        @Watch('dialogs.untersuchung')
        public onChangeDialogsUntersuchung(visible: boolean): void {
            if (!visible) {
                this.reset();
            }
        }

        public onClickSelect(): void {
            this.$emit('select', this.selected);
        }

        public onClickSolved(): void {
            for (var cnt = 0; cnt < this.selected.length; cnt++) {
                var item = this.selected[cnt];

                if (item.tag === 'untersuchung') {
                    this.setDurchgefuehrt({
                        art: 'untersuchung',
                        patuntersuchung_id: item.data.patuntersuchung_id,
                        patplanimpfstoff_id: null,
                        patplan_id: null,
                    });
                } else if (item.tag === 'impfung') {
                    this.setDurchgefuehrt({
                        art: 'impfung',
                        patuntersuchung_id: null,
                        patplanimpfstoff_id: item.data.patplanimpfstoff_id,
                        patplan_id: item.data.patplan_id,
                    });
                }
            }
            this.reset();
        }

        public onClickReset() {
            if (this.selected[0].isImpfung) {
                this.selected[0].asImpfung.impfdatum = null;

                this.resetDurchgefuehrt({
                    art: 'impfung',
                    patuntersuchung_id: null,
                    patplanimpfstoff_id: this.selected[0].data.patplanimpfstoff_id,
                    patplan_id: this.selected[0].data.patplan_id,
                });
            } else if (this.selected[0].isUntersuchung) {
                this.selected[0].asUntersuchung.untersuchungsdatum = null;
                this.selected[0].asUntersuchung.abnahmedatum = null;

                this.resetDurchgefuehrt({
                    art: 'untersuchung',
                    patuntersuchung_id: this.selected[0].data.patuntersuchung_id,
                    patplanimpfstoff_id: null,
                    patplan_id: null,
                });
            }

            this.reset();
        }

        public get isResetDisabled() {
            if (this.selected.length === 0 || this.selected.length > 1) {
                return true;
            } else if (this.selected[0].isImpfung && this.selected[0].asImpfung.impfdatum) {
                return false;
            } else if (this.selected[0].asUntersuchung && (this.selected[0].asUntersuchung.untersuchungsdatum ||
                this.selected[0].asUntersuchung.abnahmedatum)) {
                return false;
            }
            return true;
        }
    }
